export const CREDIT_CARD_MODAL_STAGE = {
  INITIAL: 'initial',
  ERROR: 'error',
}
